/** Share of the reservation total collected as partial (seña) payment in the UI. */
export const PARTIAL_PAYMENT_FRACTION = 0.3;

/** Partial amount = 30% of total, rounded to the nearest peso. Remaining = total − partial (exact). */
export function partialPaymentAmount(totalAmount: number): number {
  if (!Number.isFinite(totalAmount) || totalAmount <= 0) return 0;
  return Math.round(totalAmount * PARTIAL_PAYMENT_FRACTION);
}

export function remainingAfterPartialPayment(totalAmount: number): number {
  if (!Number.isFinite(totalAmount) || totalAmount <= 0) return 0;
  return Math.max(0, totalAmount - partialPaymentAmount(totalAmount));
}
